import { render, staticRenderFns } from "./institutional.vue?vue&type=template&id=922d5258&"
import script from "./institutional.vue?vue&type=script&lang=js&"
export * from "./institutional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports